/**
 * @module registration/creative/components/writing_samples_upload
 */

import React, { Component, PropTypes } from 'react';
import { SubmissionError } from 'redux-form';
import WritingSamplesForm from 'registration/creative/components/writing_samples_form';
import {submitWritingSamplesRequest} from 'registration/creative/ducks';

/**
 * Writing samples upload.
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
class WritingSamplesUpload extends Component {

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(formData) {
    const { user, group, onDone, updateLocal } = this.props;
    const data = { ...formData, subcategory_group_id: group.id };

    return submitWritingSamplesRequest(user.profile_data.id, data)
      .then((res) => {
        /* if submission was successful, update the store so it's in a consistent state */
        updateLocal(group.id, formData);
        onDone();
      })
      .catch((res) => {
        /* field-specific errors */
        const data = res.data;
        if (data) {
          for (const field of Object.keys(data)) {
            if (data[field]) throw new SubmissionError({ [field]: data[field][0] });
          }
        }
        /* global error */
        throw new SubmissionError({ _error: 'Unknown error. Please try again.' });
      });
  }

  render() {
    const { samples, group, onDone } = this.props;

    return (
      <div className="writing-samples-upload">
        <h4>
          Before we approve you to participate in naming projects, you must demonstrate your
          skills and qualifications by answering the following questions.
        </h4>

        <WritingSamplesForm onSubmit={this.handleSubmit} onCancel={onDone}
          initialValues={samples[group.id]} />
      </div>
    );
  }
}

WritingSamplesUpload.propTypes = {
  user: PropTypes.object.isRequired,
  group: PropTypes.object.isRequired,
  samples: PropTypes.object,
  updateLocal: PropTypes.func.isRequired,
  onDone: PropTypes.func
};

export default WritingSamplesUpload;



// WEBPACK FOOTER //
// ./registration/creative/components/writing_samples_upload.jsx